import Repair41_3Header from "./Header";
import "./index.css";
import { useState } from "react";
import InputsFromRepair41_3a from "../ProdUseStage41/InputsFromRepair41_3a";
import SurplusResourcesRepair41_3b from "../ProdUseStage41/SurplusResourcesRepair41_3b";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";

const ProdRepair41_3Components = ({ productId }) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });
  const [totalProdItem, setTotalProdItem] = useState([]);

  return (
    <div className="prod-repair-41-3-container" id="prod-repair-41-3-id">
      <Repair41_3Header
        productId={productId}
        show={show}
        totalProdItem={totalProdItem}
      />
      <ShowHide show={show} setShow={setShow} />
      {show && (
        <div className="prod-component-contents">
          <InputsFromRepair41_3a productId={productId} />
          <SurplusResourcesRepair41_3b productId={productId} />
        </div>
      )}
    </div>
  );
};

export default ProdRepair41_3Components;

